(function () {
  var STORAGE_KEY = 'dw_quiz_won';
  var DISCOUNT_CODE = 'Magnet4Free';
  var PRODUCT_URL = '/products/magnetischer-kartenhalter-35pt-transparente-premium-kartenhulle-mit-uv-schutz-fur-sammel-trading-cards';
  var VARIANT_ID = 57094339527040;

  try {
    var wonAt = localStorage.getItem(STORAGE_KEY);
    if (wonAt && (Date.now() - parseInt(wonAt)) < 7 * 24 * 60 * 60 * 1000) return;
  } catch(e) {}

  var questions = [
    {
      q: 'Welches ­Pokémon ist gelb, hat rote Backen und einen Blitz-Schwanz?',
      answers: ['Raichu', 'Pikachu', 'Pichu'],
      correct: 1
    },
    {
      q: 'Zu welchem Pokémon entwickelt sich Glumanda am Ende?',
      answers: ['Bisaflor', 'Turtok', 'Glurak'],
      correct: 2
    },
    {
      q: 'Welches Produkt schützt Sammelkarten am besten vor Knicken?',
      answers: ['Magnetischer Toploader', 'Normales Sleeve', 'Hosentasche'],
      correct: 0
    }
  ];

  var css = `
    #dw-quiz-btn {
      position: fixed; bottom: 80px; right: 16px; z-index: 9000;
      background: linear-gradient(135deg,#c0392b,#e74c3c);
      color: #fff; border: none; border-radius: 50px;
      padding: 12px 18px; font-size: 14px; font-weight: 700;
      cursor: pointer; box-shadow: 0 4px 18px rgba(0,0,0,.45);
      display: flex; align-items: center; gap: 8px;
      font-family: inherit; letter-spacing: .3px;
      animation: dw-pulse 2.5s infinite;
    }
    @keyframes dw-pulse {
      0%,100%{box-shadow:0 4px 18px rgba(231,76,60,.55);}
      50%{box-shadow:0 4px 28px rgba(231,76,60,.9),0 0 0 6px rgba(231,76,60,.15);}
    }
    #dw-quiz-btn:hover { transform: scale(1.05); }
    #dw-quiz-overlay {
      display: none; position: fixed; inset: 0; z-index: 9999;
      background: rgba(0,0,0,.75); backdrop-filter: blur(3px);
      align-items: center; justify-content: center;
    }
    #dw-quiz-overlay.dw-open { display: flex; }
    #dw-quiz-box {
      background: #1a1a1a; border: 2px solid #e74c3c;
      border-radius: 16px; padding: 28px 24px; max-width: 420px; width: 92%;
      color: #fff; font-family: inherit; position: relative;
      box-shadow: 0 8px 40px rgba(0,0,0,.7);
    }
    #dw-quiz-box h2 {
      margin: 0 0 6px; font-size: 20px; color: #e74c3c;
      display: flex; align-items: center; gap: 8px;
    }
    .dw-badge { font-size: 11px; background:#e74c3c; color:#fff; border-radius:20px; padding:2px 9px; vertical-align:middle; }
    #dw-quiz-progress { font-size: 12px; color: #aaa; margin-bottom: 18px; }
    .dw-progress-bar { height: 4px; background: #333; border-radius: 4px; margin-top: 6px; }
    .dw-progress-fill { height: 100%; background: #e74c3c; border-radius: 4px; transition: width .4s; }
    #dw-quiz-question { font-size: 16px; line-height: 1.5; margin-bottom: 18px; font-weight: 600; }
    .dw-answer {
      display: block; width: 100%; background: #2a2a2a; border: 2px solid #444;
      color: #fff; border-radius: 10px; padding: 11px 14px; margin-bottom: 10px;
      font-size: 14px; font-family: inherit; cursor: pointer; text-align: left;
      transition: border-color .2s, background .2s;
    }
    .dw-answer:hover { border-color: #e74c3c; background: #2e2e2e; }
    .dw-answer.dw-correct { border-color: #27ae60; background: #1a3a2a; }
    .dw-answer.dw-wrong { border-color: #c0392b; background: #3a1a1a; }
    #dw-quiz-win, #dw-quiz-lose { display: none; text-align: center; }
    #dw-quiz-win h3 { font-size: 22px; color: #f1c40f; margin: 0 0 8px; }
    #dw-quiz-lose h3 { font-size: 20px; color: #e74c3c; margin: 0 0 8px; }
    .dw-code-box {
      background: #0d0d0d; border: 2px dashed #f1c40f;
      border-radius: 10px; padding: 14px; margin: 16px 0;
      font-size: 22px; font-weight: 900; color: #f1c40f;
      letter-spacing: 3px; cursor: pointer;
    }
    .dw-code-box small { display:block; font-size:11px; color:#aaa; letter-spacing:0; font-weight:400; margin-top:4px; }
    .dw-btn-red {
      display: inline-block; background: linear-gradient(135deg,#c0392b,#e74c3c);
      color: #fff; border: none; border-radius: 8px; padding: 13px 22px;
      font-size: 15px; font-weight: 700; cursor: pointer; font-family: inherit;
      text-decoration: none; margin-top: 8px; width: 100%; text-align: center;
    }
    .dw-btn-red:hover { opacity: .9; }
    .dw-btn-ghost {
      display: inline-block; background: transparent; color: #aaa;
      border: 1px solid #444; border-radius: 8px; padding: 10px 22px;
      font-size: 13px; cursor: pointer; font-family: inherit; margin-top: 8px;
      width: 100%; text-align: center;
    }
    #dw-quiz-close {
      position: absolute; top: 12px; right: 14px;
      background: none; border: none; color: #888; font-size: 22px;
      cursor: pointer; line-height: 1; padding: 0;
    }
    #dw-quiz-close:hover { color: #fff; }
    .dw-stars { font-size: 28px; margin-bottom: 8px; }
    .dw-confetti { font-size: 32px; animation: dw-spin .8s ease; display:block; margin-bottom:6px; }
    @keyframes dw-spin { from{transform:rotate(-20deg) scale(.5);opacity:0;} to{transform:rotate(0) scale(1);opacity:1;} }
  `;

  var html = `
    <button id="dw-quiz-btn" title="Pokémon-Quiz spielen & gewinnen">
      🎮 Quiz & Gratis-Preis!
    </button>
    <div id="dw-quiz-overlay" role="dialog" aria-modal="true">
      <div id="dw-quiz-box">
        <button id="dw-quiz-close" aria-label="Schließen">&times;</button>
        <div id="dw-quiz-content">
          <h2>🎮 Pokémon-Quiz <span class="dw-badge">GRATIS PREIS</span></h2>
          <div id="dw-quiz-progress">
            Frage <span id="dw-qnum">1</span> von 3
            <div class="dw-progress-bar"><div class="dw-progress-fill" id="dw-qbar" style="width:33%"></div></div>
          </div>
          <p id="dw-quiz-question"></p>
          <div id="dw-quiz-answers"></div>
        </div>
        <div id="dw-quiz-win">
          <span class="dw-confetti">🏆</span>
          <h3>Du hast gewonnen! 🎉</h3>
          <p style="color:#ccc;font-size:14px">3/3 richtig! Dein Preis: <strong style="color:#f1c40f">Magnetischer Toploader GRATIS!</strong></p>
          <div class="dw-code-box" id="dw-code-click" title="Klicken zum Kopieren">
            Magnet4Free
            <small>📋 Klicken zum Kopieren &bull; Ab 9,99€ Bestellwert • 1× pro Kunde</small>
          </div>
          <a class="dw-btn-red" href="/products/magnetischer-kartenhalter-35pt-transparente-premium-kartenhulle-mit-uv-schutz-fur-sammel-trading-cards">
            🛒 Jetzt einlösen &rarr;
          </a>
          <button class="dw-btn-ghost" id="dw-quiz-close2">Später</button>
        </div>
        <div id="dw-quiz-lose">
          <div class="dw-stars">😔</div>
          <h3>Knapp daneben!</h3>
          <p style="color:#ccc;font-size:14px">Das war leider falsch. Schau dich in unserem Blog um – da findest du alle Antworten!</p>
          <button class="dw-btn-red" id="dw-quiz-retry">Nochmal versuchen</button>
          <button class="dw-btn-ghost" id="dw-quiz-close3">Schließen</button>
        </div>
      </div>
    </div>
  `;

  var styleEl = document.createElement('style');
  styleEl.textContent = css;
  document.head.appendChild(styleEl);
  var wrapper = document.createElement('div');
  wrapper.innerHTML = html;
  document.body.appendChild(wrapper);

  var currentQ = 0;
  var overlay = document.getElementById('dw-quiz-overlay');

  function showQ(idx) {
    var q = questions[idx];
    document.getElementById('dw-qnum').textContent = idx + 1;
    document.getElementById('dw-qbar').style.width = ((idx + 1) / 3 * 100) + '%';
    document.getElementById('dw-quiz-question').textContent = q.q;
    var ans = document.getElementById('dw-quiz-answers');
    ans.innerHTML = '';
    q.answers.forEach(function(a, i) {
      var btn = document.createElement('button');
      btn.className = 'dw-answer';
      btn.textContent = a;
      btn.addEventListener('click', function() { pick(i, btn); });
      ans.appendChild(btn);
    });
  }

  function pick(idx, btn) {
    var q = questions[currentQ];
    document.querySelectorAll('.dw-answer').forEach(function(b) { b.disabled = true; });
    if (idx === q.correct) {
      btn.classList.add('dw-correct');
      btn.textContent = '✅ ' + btn.textContent;
      currentQ++;
      if (currentQ < 3) {
        setTimeout(function() { showQ(currentQ); }, 700);
      } else {
        setTimeout(showWin, 700);
      }
    } else {
      btn.classList.add('dw-wrong');
      document.querySelectorAll('.dw-answer')[q.correct].classList.add('dw-correct');
      setTimeout(showLose, 900);
    }
  }

  function showWin() {
    document.getElementById('dw-quiz-content').style.display = 'none';
    document.getElementById('dw-quiz-win').style.display = 'block';
    try { localStorage.setItem(STORAGE_KEY, Date.now().toString()); } catch(e) {}
    document.getElementById('dw-quiz-btn').style.display = 'none';
  }

  function showLose() {
    document.getElementById('dw-quiz-content').style.display = 'none';
    document.getElementById('dw-quiz-lose').style.display = 'block';
  }

  function resetQuiz() {
    currentQ = 0;
    document.getElementById('dw-quiz-content').style.display = 'block';
    document.getElementById('dw-quiz-win').style.display = 'none';
    document.getElementById('dw-quiz-lose').style.display = 'none';
    showQ(0);
  }

  function closeOverlay() { overlay.classList.remove('dw-open'); }
  function openOverlay() { overlay.classList.add('dw-open'); resetQuiz(); }

  document.getElementById('dw-quiz-btn').addEventListener('click', openOverlay);
  document.getElementById('dw-quiz-close').addEventListener('click', closeOverlay);
  document.getElementById('dw-quiz-close2').addEventListener('click', closeOverlay);
  document.getElementById('dw-quiz-close3').addEventListener('click', closeOverlay);
  document.getElementById('dw-quiz-retry').addEventListener('click', resetQuiz.bind(null, 0));

  document.getElementById('dw-code-click').addEventListener('click', function() {
    if (navigator.clipboard) {
      navigator.clipboard.writeText('Magnet4Free').then(function() {
        document.getElementById('dw-code-click').querySelector('small').textContent = '✅ Kopiert!';
      });
    }
  });

  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) closeOverlay();
  });
})();